export default "/kiban/_next/static/images/45_12L_4-4-4-6da674982c5a7a42f2b752f57e66734c.png";